import { useState } from 'react'
import { WSProvider } from './contexts/WSContext'
import { ScopeProvider } from './contexts/ScopeContext'
import Sidebar from './components/Sidebar'
import Topbar from './components/Topbar'
import HomeView from './components/HomeView'
import DevicesView from './components/DevicesView'
import LiveFeedView from './components/LiveFeedView'
import MapView from './components/MapView'
import TrackingView from './components/TrackingView'
import CyclesView from './components/CyclesView'
import HolesView from './components/HolesView'
import ProductivityView from './components/ProductivityView'
import ProductionDashboard from './components/ProductionDashboard'
import TimelineView from './components/TimelineView'
import DispatchView from './components/DispatchView'
import GeofencesView from './components/GeofencesView'
import MapsAdminView from './components/MapsAdminView'
import DebugAdminView from './components/DebugAdminView'
import AlarmsView from './components/AlarmsView'
import AdminView from './components/AdminView'
import ReportPrint from './components/ReportPrint'
import Login from './components/Login'
import { VmcResetTracker } from './components/VmcReset'
import { useAuth } from './contexts/AuthContext'

function Splash() {
  return (
    <div className="flex h-screen items-center justify-center bg-offwhite dark:bg-slate-950">
      <img src="/carcosa-mark.svg" alt="" className="h-10 w-10 animate-pulse-slow" />
    </div>
  )
}

export default function App() {
  const isReport = new URLSearchParams(window.location.search).get('report') === '1'
  const [view, setView] = useState('inicio')
  // Na página de impressão não há AuthProvider (ver main.jsx), então o contexto é nulo.
  const auth = useAuth()
  // admin-debug é item próprio (como mapas/geofences), não uma aba da casca AdminView.
  const isAdmin = view.startsWith('admin-') && view !== 'admin-debug'

  // Página de impressão (Gotenberg/PDF): sem WS, sem layout, só fetch do /api/kpis.
  // Fica ANTES do gate de propósito: o Chromium do Gotenberg não tem sessão e se
  // autentica com o token de relatório, então não pode cair na tela de login.
  if (isReport) return <ReportPrint />

  const { user, loading } = auth || {}
  if (loading) return <Splash />
  // O gate envolve os providers: sem sessão não se abre WebSocket nem se disparam os
  // seis GETs de cadastro do WSProvider. E o logout desmonta essa árvore inteira, o que
  // já fecha o socket e cancela o retry de reconexão.
  if (!user) return <Login />

  return (
    <WSProvider>
      <ScopeProvider>
      <div className="flex h-screen overflow-hidden bg-offwhite dark:bg-slate-950">
        <Sidebar currentView={view} onViewChange={setView} />
        <div className="flex-1 flex flex-col overflow-hidden min-w-0">
          <Topbar view={view} />
          <main className="flex-1 overflow-hidden relative">
            <div className={view === 'inicio'       ? 'h-full' : 'hidden'}>{view === 'inicio' && <HomeView onViewChange={setView} />}</div>
            <div className={view === 'equipamentos' ? 'h-full' : 'hidden'}><DevicesView  visible={view === 'equipamentos'} /></div>
            <div className={view === 'eventos'       ? 'h-full' : 'hidden'}><LiveFeedView visible={view === 'eventos'} /></div>
            <div className={view === 'controlador'   ? 'h-full' : 'hidden'}><MapView visible={view === 'controlador'} /></div>
            <div className={view === 'tracking'      ? 'h-full' : 'hidden'}>{view === 'tracking' && <TrackingView />}</div>
            <div className={view === 'ciclos'        ? 'h-full' : 'hidden'}>{view === 'ciclos' && <CyclesView />}</div>
            <div className={view === 'furos'         ? 'h-full' : 'hidden'}>{view === 'furos' && <HolesView />}</div>
            <div className={view === 'dashboard'     ? 'h-full' : 'hidden'}>{view === 'dashboard' && <ProductionDashboard />}</div>
            <div className={view === 'produtividade' ? 'h-full' : 'hidden'}>{view === 'produtividade' && <ProductivityView />}</div>
            <div className={view === 'timeline'      ? 'h-full' : 'hidden'}>{view === 'timeline' && <TimelineView />}</div>
            <div className={view === 'despacho'      ? 'h-full' : 'hidden'}>{view === 'despacho' && <DispatchView />}</div>
            <div className={view === 'geofences'     ? 'h-full' : 'hidden'}>{view === 'geofences' && <GeofencesView />}</div>
            <div className={view === 'mapas'         ? 'h-full' : 'hidden'}>{view === 'mapas' && <MapsAdminView />}</div>
            <div className={view === 'admin-debug'   ? 'h-full' : 'hidden'}>{view === 'admin-debug' && <DebugAdminView />}</div>
            <div className={view === 'alarmes'       ? 'h-full' : 'hidden'}>{view === 'alarmes' && <AlarmsView />}</div>
            <div className={isAdmin ? 'h-full' : 'hidden'}>{isAdmin && <AdminView view={view} onViewChange={setView} />}</div>
          </main>
        </div>
      </div>
      {/* Fora das telas: o acompanhamento do reset de VMC sobrevive ao card e ao drawer
          do equipamento, que somem quando o callback o apaga. */}
      <VmcResetTracker />
      </ScopeProvider>
    </WSProvider>
  )
}
